"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoExampleValueAndExternalValue = void 0;
exports.NoExampleValueAndExternalValue = () => {
    return {
        Example(example, { report, location }) {
            if (example.value && example.externalValue) {
                report({
                    message: 'Example object can have either `value` or `externalValue` fields.',
                    location: location.child(['value']).key(),
                });
            }
        },
    };
};
